import { useSwipeable } from "react-swipeable";
import { useState, useMemo } from "react";

export function useProductSwipe(products = []) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const safeProducts = useMemo(() => {
    return Array.isArray(products) ? products : [];
  }, [products]);

  const total = safeProducts.length;

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      if (total > 0) {
        setCurrentIndex((prev) => (prev + 1) % total);
      }
    },
    onSwipedRight: () => {
      if (total > 0) {
        setCurrentIndex((prev) => (prev - 1 + total) % total);
      }
    },
    trackMouse: true,
  });

  return {
    swipeHandlers,
    currentIndex,
    currentProduct: total > 0 ? safeProducts[currentIndex] : null,
    total,
  };
}

